import { render, staticRenderFns } from "./reservation-table.vue?vue&type=template&id=37d51332&scoped=true&"
import script from "./reservation-table.vue?vue&type=script&lang=js&"
export * from "./reservation-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d51332",
  null
  
)

export default component.exports